import { AsyncLocalStorage } from 'async_hooks';
import { v4 as uuidV4 } from 'uuid';

import { REQUEST_ID_STORE_KEY } from '../SearchBar/search-bar.constants';

type ContinuationStore = Map<string, any>;

const browserAsyncLocalStorageMock = {
  run: (o: ContinuationStore, callback: () => void) => callback(),
  getStore: () => null,
  enterWith: () => false,
};

const generateUUID = (): string => {
  return `generated-id-${uuidV4()}`;
};

const asyncLocalStorage = AsyncLocalStorage
  ? new AsyncLocalStorage()
  : browserAsyncLocalStorageMock;

const getContinuationStore = (): ContinuationStore => {
  return asyncLocalStorage.getStore() as ContinuationStore;
};

export const getContinuationRequestId = (forceGenerateID = false): string => {
  const fallbackRequestId = forceGenerateID ? generateUUID() : null;

  const store = getContinuationStore();
  return store?.get(REQUEST_ID_STORE_KEY)?.toString() || fallbackRequestId;
};
